const TickMarkBlueColor = (props) => (
  <svg
    width={94}
    height={94}
    viewBox="0 0 94 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M47 0C21.08 0 0 21.08 0 47C0 72.92 21.08 94 47 94C72.91 94 94 72.92 94 47C94 21.08 72.91 0 47 0ZM71.62 35.37L42.74 64.28C41.99 65.04 40.969 65.46 39.91 65.46C38.849 65.46 37.83 65.04 37.08 64.29L22.37 49.57C20.809 48.01 20.809 45.48 22.37 43.92C23.93 42.35 26.47 42.35 28.03 43.92L39.91 55.8L65.96 29.72C67.53 28.15 70.06 28.15 71.62 29.71C73.18 31.27 73.19 33.81 71.62 35.37Z"
      fill="#2F59A7"
    />
  </svg>
);


export default TickMarkBlueColor;